module.exports = __webpack_public_path__ + "static/media/AVANTRA.c70ed2f4.svg";